import { Box } from '@mui/material';
import React from 'react';

import {
  CharacterIcon,
  mapCharacterIconToFilePath,
} from '../SceneCanvas/CharacterIcon';

export interface CharacterIconPickerProps {
  onChange: Function;
}

export const CharacterIconPicker: React.FC<CharacterIconPickerProps> = ({
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        marginBottom: '10px',
        width: '420px',
        height: '320px',
        overflowY: 'scroll',
        padding: '16px',
      }}
    >
      {Object.keys(CharacterIcon)
        .filter((iconkey: string) => iconkey !== 'DEFAULT')
        .map((iconkey: string) => {
          return (
            <div
              key={'pickerdiv_' + iconkey}
              style={{
                width: '128px',
                height: '90px',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <img
                alt={iconkey}
                key={'picker_' + iconkey}
                src={mapCharacterIconToFilePath(iconkey as CharacterIcon)}
                onClick={() => onChange(iconkey as CharacterIcon)}
              />
            </div>
          );
        })}
    </Box>
  );
};
